import get from 'transmute/get';
import { createAction } from '@reduxjs/toolkit';
import { selectThread } from '../selected-thread/actions/selectThread';
import { STUBBED_THREAD_ID } from '../threads/constants/stubbedThreadId';
import { GET_WIDGET_DATA_SUCCEEDED, RECEIVED_WIDGET_SHELL_DATA } from '../constants/VisitorActionTypes';
import { trackInteraction } from '../usage-tracking/actions/trackInteraction';
import { EVENT_NAMES, EVENT_SAMPLE_RATES } from '../usage-tracking/constants/eventNames';
// @ts-expect-error not typed
import { buildWidgetData } from '../widget-data/operators/buildWidgetData';
// @ts-expect-error not typed
import { bootstrapInitialWidgetUi } from '../initial-message-bubble/actions/bootstrapInitialWidgetUi';
// @ts-expect-error not typed
import { messageCookieHandler } from '../gdpr/operators/messageCookieHandler';
import { trackPageViewMetric } from '../usage-tracking/utils/trackMetric';

// @ts-expect-error not typed

import { getIsOpen } from '../selectors/getIsOpen';
import { getIsMobile } from '../selectors/getIsMobile';
import { getUsePillLauncher } from '../widget-data/selectors/widgetDataSelectors';
import { shouldShowPillLauncher } from '../utils/shouldShowPillLauncher';
export const receivedWidgetData = createAction(GET_WIDGET_DATA_SUCCEEDED, widgetData => ({
  payload: widgetData
}));
export const receivedWidgetShellData = createAction(RECEIVED_WIDGET_SHELL_DATA, widgetData => ({
  payload: widgetData
}));
export default function bootstrapWidget(data) {
  return (dispatch, getState) => {
    trackPageViewMetric();
    const widgetData = buildWidgetData(data);
    if (!get('sessionId', widgetData) || !get('chatflowId', widgetData)) {
      return;
    }
    dispatch(selectThread(STUBBED_THREAD_ID));
    messageCookieHandler({
      currentState: getState(),
      widgetData
    });
    dispatch(receivedWidgetData(widgetData));
    dispatch(receivedWidgetShellData(data));
    dispatch(bootstrapInitialWidgetUi(widgetData));
    const currentState = getState();
    const isOpen = getIsOpen(currentState);
    const mobile = getIsMobile(currentState);
    const usePillLauncher = getUsePillLauncher(currentState);
    const showPillLauncher = shouldShowPillLauncher({
      usePillLauncher,
      hasOpenedWidget: isOpen,
      mobile
    });
    const launcherType = showPillLauncher ? 'pill' : 'icon';
    if (Math.random() < EVENT_SAMPLE_RATES.PAGE_VIEW) {
      dispatch(trackInteraction(EVENT_NAMES.PAGE_VIEW, {
        screen: 'widget',
        action: 'rendered widget',
        launcherType,
        isOpen,
        sampleRate: EVENT_SAMPLE_RATES.PAGE_VIEW
      }));
    }
  };
}